/**
 * CarMatsCulture Ambassador Landing Page JavaScript
 * Handles smooth scrolling and scroll-triggered animations
 */

(function() {
  'use strict';

  // Smooth scroll to signup form
  function initSmoothScroll() {
    const scrollButtons = document.querySelectorAll('.scroll-to-form');
    
    scrollButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('data-scroll-target') || this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const headerOffset = 80; // Adjust if you have a sticky header
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Scroll-triggered animations
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    
    if (animatedElements.length === 0) return;
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          
          // Stagger child animations if they exist
          const children = entry.target.querySelectorAll('.benefit-card, .faq-item, .partnership-logo-item');
          children.forEach((child, index) => {
            setTimeout(() => {
              child.style.animationDelay = `${index * 0.1}s`;
              child.classList.add('animate-in');
            }, index * 100);
          });
          
          // Stop observing after animation
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    animatedElements.forEach(element => {
      observer.observe(element);
    });
  }

  // FAQ accordion functionality (backup if inline onclick doesn't work)
  function initFAQAccordion() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      // Remove existing onclick to prevent double binding
      question.removeAttribute('onclick');
      
      question.addEventListener('click', function() {
        const faqItem = this.parentElement;
        const isActive = faqItem.classList.contains('active');
        
        // Close all other FAQ items (optional - remove if you want multiple open)
        // document.querySelectorAll('.faq-item.active').forEach(item => {
        //   if (item !== faqItem) {
        //     item.classList.remove('active');
        //     item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        //   }
        // });
        
        // Toggle current item
        if (isActive) {
          faqItem.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
        } else {
          faqItem.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Initialize on DOM ready
  function init() {
    initSmoothScroll();
    initScrollAnimations();
    initFAQAccordion();
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section render (for theme editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
